export enum CustomUserPermissionTabs {
  Tracker = 'tracker-tab',
  Partner = 'partner-tab',
}
